import { TURKIYE_CITY_DISTRICT_OPTIONS } from '../data/turkiyeDistricts';

export const CITY_DISTRICT_OPTIONS = TURKIYE_CITY_DISTRICT_OPTIONS;

export const CITY_OPTIONS = Object.keys(CITY_DISTRICT_OPTIONS);

function normalizeLocationKey(value) {
  return String(value || '')
    .trim()
    .toLocaleLowerCase('tr-TR')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ı/g, 'i');
}

export function resolveCanonicalCityName(city) {
  const raw = String(city || '').trim();
  if (!raw) return '';
  if (CITY_DISTRICT_OPTIONS[raw]) return raw;

  const normalizedRaw = normalizeLocationKey(raw);
  return CITY_OPTIONS.find((option) => normalizeLocationKey(option) === normalizedRaw) || '';
}

export function getDistrictOptions(city) {
  const canonicalCity = resolveCanonicalCityName(city);
  return CITY_DISTRICT_OPTIONS[canonicalCity] || [];
}
